import styled, { css } from 'styled-components';

interface TableHeadProps {
  sticky?: boolean;
}

const TableHead = styled.thead.attrs({ role: 'rowgroup' })<TableHeadProps>`
  display: table-header-group;
  ${({ sticky }) =>
    sticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 1;
    `}
`;

export default TableHead;
